import script from "./GeorgiaDfcsBenefitsApplicationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeorgiaDfcsBenefitsApplicationForm.vue?vue&type=script&lang=ts&setup=true"

import "./GeorgiaDfcsBenefitsApplicationForm.vue?vue&type=style&index=0&id=c77a5180&lang=scss&scoped=true"
import "./GeorgiaDfcsBenefitsApplicationForm.vue?vue&type=style&index=1&id=c77a5180&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c77a5180"]])

export default __exports__